export default {
    //基礎通用
    base:{
        search:'搜索',
        serial:'序號',
        handle:'操作',
        prev:'上一步',
        next:'下一步',
        save:'保存',
        close:'關閉',
        cancel:'取消',
        ciMin:'次/分',
        second:'秒',
        totalText:'全部',
        records:'條',
        noDataTip:'暫無數據',
        continue:'持續中',     //***
        end:'已結束',          //***
        unsettled:'未處理',
        settled:'已處理',
        settle:'處理',
        total:'總共'        //***
    },
    //登錄
    login:{
        sysName:'安福星健康管理系統',
        userName:'用戶名',
        unPlaceholder:'請輸入用戶名',
        password:'密碼',
        pwPlaceholder:'請輸入密碼',
        enter:'確認',
        changelag:'切換語言'
    },
    //登錄-語言選擇彈窗
    lagDialog:{
        selectLag:'請選擇語言',
        finish:'完成',
        close:'關閉'
    },
    //菜單路由
    route:{
        // home:'首頁',
        monitorCenter:'監控中心',
        monitorManage:'實時監控',
        realTimeWarning:'實時報警',
        equipUserCenter:'用戶中心',
        equipUserManage:'用戶管理',
        equipUserHealthManage:'用戶健康管理',
        equipUserBindManage:'用戶設備綁定管理',
        equipCenter:'設備中心',
        equipManage:'設備管理',
        alarmCenter:'報警中心',
        alarmManage:'報警管理',
        organizaCenter:'機構中心',   //*
        administrativeDivision:'行政區劃',
        systemManage:'系統設置',
        menuConfig:'菜單配置',
        accountManage:'帳戶管理',   //*
        roleManage:'角色管理',   //*
        deptManage:'部門管理',
        unitManage:'機構管理',
        dutiesManage:'職務管理',
        dataItemManage:'字典分類管理',
        dataItemDetailsManage:'字典詳情管理'
    },
    //外殼
    layout:{
        logoName:'Anvenus',
        perMes:'個人資訊',
        logOut:'退出'
    },
    //首頁
    home:{
        area:'區域',
        realTimeStatistic:'即時統計',
        freshTip:'在床率(每30分鐘刷新)',
        alarmNum:'報警數量',
        inBed:'在床情況',
        sexRatio:'性別占比',
        warnType1:'報警類型1',
        warnType2:'報警類型2',
        totalWarnNum:'總報警數',
        warnCase:'報警情況',
        totalNum:'總數',
        onLine:'當前線上',
        onBed:'當前在床',
        offBed:'當前離床',
        offLine:'當前離線',
        people:'人'
    },
    //監控中心-即時視頻
    monitorManage:{
        searchPlaceText:'請輸入用戶姓名',
        dialog2Title:'今日預警記錄',
        heartRate:'心率',
        breathRate:'呼吸',
        realWarnMes:'即時預警',
        normalState:'正常',
        timeSlot:'時間段',
        totalRecord:'共有記錄'


    },
    //监控中心-实时报警
    realTimeWarning:{
        last:'持續',       //***
        seconds:'秒'       //***
    },
    //用戶中心-用戶管理
    userManage:{
        userManagement:'用戶管理',
        searchPlaceText:'請輸入用戶姓名或電話',
        firstName:'名',
        lastName:'姓',
        name:'姓名',
        age:'年齡',
        birthDate:'出生日期',
        gender:'性別',
        address:'地址',
        email:'郵箱',
        phoneNumber:'電話',
        userAdd:'用戶新增',   //開始
        userDetail:'用戶詳情',
        userEdit:'用戶編輯',
        accountMes:'帳號資訊',
        advancedMes:'進階資訊',
        enterMes:'確認資訊',
        baseMes:'基本資訊',
        addressMes:'住址資訊',
        detailAddress:'詳細地址',
        postCode:'郵編',
        firstNameRule:'名不能為空',
        lastNameRule:'姓不能為空',
        phoneNumberRule:'電話不能為空',
        emailRule:'郵箱不能為空',
        birthDateRule:'出生日期不能為空',
        genderRule:'性別不能為空',
        addressRule:'詳細地址不能為空',
        belongStateRule:'州不能為空',
        belongAreaRule:'區不能為空',
        postCodeRule:'郵編不能為空'
    },
    //用戶中心-用戶健康管理
    userHealthManage:{
        userHealthManage:'用戶健康管理',
        searchPlaceText:'請輸入用戶姓名或電話',
        firstName:'名',
        lastName:'姓',
        name:'姓名',
        birthDate:'出生日期',
        gender:'性別',
        phoneNumber:'電話',
        heartRange:'心跳閾值',
        breathRange:'呼吸閾值',
        userState:'用戶狀態',
        leaveBedTime:'離床報警時間',
        isConfig:'是否設置',
        setInitVal:'設置初始閾值',
        editYuZhi:'編輯閾值',
        heartMes:'心率閾值（在心率低於最低閾值或高於最高閾值時會記錄為異常狀態',
        breathMes:'呼吸率閾值（在呼吸率低於最低閾值或高於最高閾值時會記錄為異常狀態）',
        sleepMes:'睡眠監控資訊',
        minThreshold:'最低閾值',
        maxThreshold:'最高閾值',
        sleepTimeBegin:'睡眠開始時間',
        sleepTimeEnd:'睡眠結束時間'


    },
    //用戶中心-用戶設備綁定管理
    userBindManage:{
        userBindManage:'用戶設備綁定管理',
        searchPlaceText:'請輸入用戶姓名或電話',
        firstName:'名',
        lastName:'姓',
        name:'姓名',
        birthDate:'出生日期',
        gender:'性別',
        phoneNumber:'電話',
        isBind:'綁定狀態',
        deviceCode:'綁定設備ID',
        equipBind:'設備綁定',
        deviceCodeRule:'設備不能為空',
        confirmMes1:'解綁設備將不會繼續獲取',
        confirmMes2:'的用戶數據 確定解綁嗎？',
        confirmMes3:'提示',

    },
    //設備中心-設備管理
    equipManage:{
        equipManage:'設備管理',
        searchPlaceText:'請輸入設備ID',
        deviceCode:'設備ID',
        version:'固件版本',
        isBind:'是否綁定',
        bindName:'用戶姓名',
        belongTenantName:'所屬機構',
        runTypeName:'運行模式',
        currentState:'當前狀態',
        equipAdd:'設備新增',
        equipEdit:'設備編輯'
    },
    //報警中心-報警管理
    alarmManage:{
        alarmManage:'報警管理',
        searchPlaceText:'請輸入用戶姓名',
        heartMes:'心率異常預警',
        breathMes:'呼吸異常預警',
        heartStopMes:'心率停止異常預警',
        breathStopMes:'呼吸停止異常預警',
        leaveBedMes:'離床預警',
        alarmVoice:'預警聲音',
        alarmSet:'報警設置',
        alarmDetail:'報警詳情',
        date:'時間',
        heartErrorCount:'心率異常',
        breathErrorCount:'呼吸異常',
        heartStopCount:'心率停止異常',
        breathStopCount:'呼吸停止異常',
        leaveBedCount:'離床預警',
        startPlaceholder:'開始時間',
        endPlaceholder:'結束時間',
        userName:'姓名',
        begin:'時間',
        waringTypeName:'報警類型',
        waringState:'報警時狀態',
        waringHeart:'報警時心率',
        waringBreath:'報警時呼吸率'
    },
    //行政區劃
    administrativeDivision:{
        administrativeDivision:'行政區劃',
        searchPlaceText:'請輸入名稱',
        name:'名稱',
        dataTypeName:'類型',
        description:'備註',
        adminAdd:'區域新增',
        adminDetail:'區域詳情',
        adminEdit:'區域編輯',
        parentId:'上級',
        dataType:'類型',
        nameRule:'名字不能為空',
        dataTypeRule:'類型不能為空'
    },
    //系統設置-菜單設置
    menuConfig:{
        menuConfig:'菜單列表',
        searchPlaceText:'請輸入菜單名稱',
        name:'菜單名',
        moduleType:'菜單類型',
        menuIcon:'菜單圖示',
        url:'菜單路由',
        sort:'排序',
        description:'備註',
        nameRule:'菜單名稱不能為空',
        urlRule:'路由不能為空',
        menuAdd:'菜單新增',
        menuDetail:'菜單詳情',
        menuEdit:'菜單編輯',
        parentId:'上級',
        moduleButtons:'頁面按鈕'
    },
    users:{
        users:'帳戶管理',
        searchPlaceText:'請輸入帳戶名稱',
        userName:'帳號',
        name:'姓名',
        gender:'性別',
        phoneNumber:'手機號',
        tenantId:'機構',
        password:'密碼',
        roleIds:'角色',
        email:'郵箱',
        accountMes:'帳戶資訊',
        dataPermiss:'數據許可權',
        userNameRule:'用戶帳號不能為空',
        passwordRule:'用戶密碼不能為空',
        roleRule:'角色不能為空',
        userAdd:'帳戶新增',
        userDetail:'帳戶詳情',
        userEdit:'帳戶編輯',
    },
    roles:{
        roles:'角色管理',
        searchPlaceText:'請輸入角色名稱',
        code:'角色編號',
        name:'角色名稱',
        description:'角色描述',
        roleMes:'角色資訊',
        permissMes:'角色許可權',
        nameRule:'角色名稱不能為空',
        codeRule:'角色編碼不能為空',
        roleAdd:'角色新增',
        roleDetail:'角色詳情',
        roleEdit:'角色編輯',
    },
    deptManage:{
        deptManage:'部門管理',
        searchPlaceText:'請輸入部門名稱',
        unit:'機構',
        dept:'部門',
        parentDepartmentId:'上級部門',
        name:'名稱',
        code:'編號',
        manager:'管理者',
        phone:'電話',
        description:'備註',
        nameRule:'部門名稱不能為空',
        deptAdd:'部門新增',
        deptDetail:'部門詳情',
        deptEdit:'部門編輯',
    },
    unitManage:{
        unitManage:'機構管理',
        searchPlaceText:'請輸入機構名稱',
        parentId:'上級機構',
        name:'名稱',
        code:'編號',
        manager:'管理者',
        phone:'電話',
        address:'地址',
        tenantLevel:'機構類別',
        description:'備註',
        nameRule:'部門名稱不能為空',
        unitAdd:'機構新增',
        unitDetail:'機構詳情',
        unitEdit:'機構編輯'
    },
    dutiesManage:{
        dutiesManage:'職位管理',
        searchPlaceText:'請輸入職位名稱',
        name:'職位名稱',
        code:'職位編碼',
        description:'職位說明',
        nameRule:'職位名稱不能為空',
        dutiesAdd:'職位新增',
        dutiesDetail:'職位詳情',
        dutiesEdit:'職位編輯'
    },
    dataItemManage:{
        dataItemManage:'字典分類管理',
        searchPlaceText:'請輸入字典分類名稱',
        parentId:'上級字典',
        itemName:'字典名稱',
        itemCode:'字典編碼',
        sort:'排序',
        description:'備註',
        itemNameRule:'字典名稱不能為空',
        itemCodeRule:'字典編碼不能為空',
        dataItemAdd:'字典分類新增',
        dataItemDetail:'字典分類詳情',
        dataItemEdit:'字典分類編輯'
    },
    dataDetailManage:{
        dataDetailManage:'字典詳情管理',
        searchPlaceText:'請輸入字典名稱',
        codeType:'字典類別' ,
        codeDetail:'字典詳情',
        itemId:'上級字典',
        itemName:'字典名稱',
        itemValue:'字典編碼',
        sort:'排序',
        description:'備註',
        itemNameRule:'字典名稱不能為空',
        itemValueRule:'字典編碼不能為空',
        dataDetailAdd:'字典新增',
        dataDetailDetail:'字典詳情',
        dataDetailEdit:'字典編輯'
    },
    //字典分類
    codeSort:{
        CYZD:'常用字典',
        SYF:'是與否',
        XB:'性別',
        XTZD:'系統字典',
        XTAN:'系統按鈕',
        CDLX:'菜單類型',
        SBZX:'設備中心',
        SBZT:'設備狀態',
        SFBD:'是否綁定',
        JGZX:'機構中心',
        XZLB:'行政類別',
        BJZX:'報警中心',
        BJLB:'報警類別',
        BJSY:'報警聲音',
        BJZT:'報警狀態',
        YHZX:'用戶中心',
        YHZT:'用戶狀態',
        SFSZYZ:'是否設置閾值',
        YDDJK:'移動端健康',
        YHGX:'用戶關係'
    },
    codeDetail:{
        yes:'是',
        no:'否',
        man:'男',
        women:'女',
        add:'新增',
        edit:'編輯',
        remove:'刪除',
        details:'詳情',
        exportExcel:'導出Excel',
        importExcel:'導入Excel',
        initYuZhi:'初始值設置',
        chongzhi:'重置',
        bind:'綁定',
        unbind:'解綁',
        baojingshezhi:'報警設置',
        sysMenu:'系統菜單',
        listMenu:'目錄菜單',
        offLine:'離線',
        offBed:'離床',
        onBed:'在床',
        state:'州',
        suburb:'區',
        district:'分區',
        allType:'全部類型',
        lowHeartRate:'低心率',
        highHeartRate:'高心率',
        lowRespiratoryRate:'呼吸過緩',
        highRespiratoryRate:'呼吸過速',
        apnea:'呼吸暫停',
        absenceofVitalSigns:'無生命體征',
        outofBedTimeout:'離床超時',
        movement:'體動',
        music1:'music1',
        music2:'music2',
        music3:'music3',
        music4:'music4',
        music5:'music5',
        normalState:'正常狀態',
        longTermBed:'長期臥床',
        initVal:'初始值',
        hadSet:'已設置',
        hadBind:'已綁定',
        unBind:'未綁定'
    },
    errorMes:{
        err200:'操作成功',
        err500:'系統錯誤！',
        err401:'未授權或者已過期，請重新登錄!',
        err400:'請求錯誤(400)',
        ExcelImportExport_Error1:'請上傳檔!',
        ExcelImportExport_Error2:'請填寫範本數據!',
        ExcelImportExport_Error3:'導入失敗!',
        Dev_DeviceManager_Error1:'已存在相同的設備唯一識別字!',
        Sys_DataItemDetails_Error1:'已存在相同的字典值!',
        Sys_DataItem_Error1:'已存在相同的字典編碼!',
        Sys_DataItem_Error2:'已存在相同的名稱!',
        Sys_Role_Error1:'操作失敗!',
        Sys_User_Error1:'用戶名或密碼不正確!',
        Sys_User_Error2:'無權限使用!',
        Sys_User_Error3:'已存在相同的用戶名!',
        Sys_User_Error4:'操作失敗!',
        Sys_User_Error5:'原始密碼不匹配!',
        Usc_UserHearthyManage_Error1:'請先設置系統初始閾值!',
        Usc_User_Error1:'請選擇用戶!',
        Usc_User_Error2:'請選擇出院用戶!',
        Usc_User_Error3:'此用戶已被其他設備綁定!',
    }
}
